"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = require("../store/store");
var legacy_1 = require("satcheljs/lib/legacy");
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
})(legacy_1.action('selectWeekStartDayOption')(function selectWeekStartDayOption(weekStartDay, state) {
    var optionState = state.optionState;
    optionState.weekStartDay = weekStartDay;
}));
//# sourceMappingURL=selectWeekStartDayOption.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/calendar/owa-calendar-appearance-option/lib/actions/selectWeekStartDayOption.js
// module id = 5263
// module chunks = 2